import { render } from "./BookingAdditionalQuestions.vue?vue&type=template&id=00bc5a44"
const script = {}

import exportComponent from "/home/runner/work/abdom-clean-homes-booking/abdom-clean-homes-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__